<template>
  <div class="wrapper">
    <div class="w-full flex items-center justify-center">
      <div class="card flex flex-col bg-white rounded max-w-sm w-full">
        <div class="w-full flex justify-between items-center pb-8">
          <h3 class="nxp-section-title">
            Adicione habilidades
          </h3>
          <div @click="closePage" class="closeBtn">
            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
              <path
                d="M15.5187 4.83176C15.4416 4.75451 15.3501 4.69322 15.2493 4.6514C15.1484 4.60958 15.0404 4.58806 14.9312 4.58806C14.8221 4.58806 14.714 4.60958 14.6132 4.6514C14.5124 4.69322 14.4208 4.75451 14.3437 4.83176L10.2687 8.89843L6.19374 4.82343C6.11659 4.74628 6.025 4.68508 5.92419 4.64332C5.82339 4.60157 5.71535 4.58008 5.60624 4.58008C5.49713 4.58008 5.38909 4.60157 5.28829 4.64332C5.18748 4.68508 5.09589 4.74628 5.01874 4.82343C4.94159 4.90058 4.88039 4.99217 4.83864 5.09298C4.79688 5.19378 4.77539 5.30182 4.77539 5.41093C4.77539 5.52004 4.79688 5.62808 4.83864 5.72888C4.88039 5.82968 4.94159 5.92128 5.01874 5.99843L9.09374 10.0734L5.01874 14.1484C4.94159 14.2256 4.88039 14.3172 4.83864 14.418C4.79688 14.5188 4.77539 14.6268 4.77539 14.7359C4.77539 14.845 4.79688 14.9531 4.83864 15.0539C4.88039 15.1547 4.94159 15.2463 5.01874 15.3234C5.09589 15.4006 5.18748 15.4618 5.28829 15.5035C5.38909 15.5453 5.49713 15.5668 5.60624 15.5668C5.71535 15.5668 5.82339 15.5453 5.92419 15.5035C6.025 15.4618 6.11659 15.4006 6.19374 15.3234L10.2687 11.2484L14.3437 15.3234C14.4209 15.4006 14.5125 15.4618 14.6133 15.5035C14.7141 15.5453 14.8221 15.5668 14.9312 15.5668C15.0403 15.5668 15.1484 15.5453 15.2492 15.5035C15.35 15.4618 15.4416 15.4006 15.5187 15.3234C15.5959 15.2463 15.6571 15.1547 15.6988 15.0539C15.7406 14.9531 15.7621 14.845 15.7621 14.7359C15.7621 14.6268 15.7406 14.5188 15.6988 14.418C15.6571 14.3172 15.5959 14.2256 15.5187 14.1484L11.4437 10.0734L15.5187 5.99843C15.8354 5.68176 15.8354 5.14843 15.5187 4.83176Z"
                fill="#696969" />
            </svg>
          </div>

        </div>

        <p class="nxp-subtitle-form mb-8">
          Adicione termos específicos, como "Comunicação Verbal" em vez de amplos, para destacar suas qualificações
          mais relevantes para a vaga
        </p>

        <div class="w-full flex flex-col space-y-4">
          <div class="w-full flex flex-col space-y-2">
            <label for="skill" class="nxp-label">
              Habilidade
            </label>
            <span class="nxp-sublabel">
              Máximo 40 caracteres
            </span>
            <div class="flex gap-2">
              <vs-input class="w-full no-icon-border" v-model="payload.skill" name="skill" type="text"
                @keyup="onChange" />
              <button class="nxp-skills-add-btn" :style="{ borderColor: color, background: backgroundColor }"
                @click="addSkillToArray">
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                  <path
                    d="M8.11678 8.83019H2.47314V7.31746H8.11678V1.67383H9.62951V7.31746H15.2731V8.83019H9.62951V14.4738H8.11678V8.83019Z"
                    fill="#4F4F4F" />
                </svg>
                Adicionar
              </button>
            </div>
            <span class="text-danger">
              {{ skill_error.length > 0 ? skill_error : '' }}
            </span>
          </div>

          <div class="w-full flex flex-col space-y-4">
            <div class="nxp-card-item flex p-4 pl-8 items-center" v-for="(item, index) in skills"
              :key="`skills-card-${index}`">
              <div class="nxp-vertical-bar" :style="{ background: color }"></div>
              <div class="w-full flex flex-row justify-between items-center space-y-1">
                <div class="w-full flex flex-col">
                  <p>
                    {{ item.skill }}
                  </p>
                </div>
                <button class="nxp-card-button" @click="onRemoveSkill(index)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                    <path
                      d="M7.43696 16.8067C7.06724 16.8067 6.75147 16.6759 6.48967 16.4142C6.228 16.1524 6.09717 15.8367 6.09717 15.467V5.72341H5.09717V4.64008H8.6805V3.73633H12.6805V4.64008H16.2638V5.72341H15.2638V15.458C15.2638 15.8433 15.1343 16.1644 14.8753 16.4213C14.6163 16.6783 14.2992 16.8067 13.924 16.8067H7.43696ZM14.1805 5.72341H7.1805V15.467C7.1805 15.5418 7.20453 15.6033 7.25258 15.6513C7.30064 15.6994 7.3621 15.7234 7.43696 15.7234H13.924C13.9882 15.7234 14.047 15.6967 14.1003 15.6432C14.1538 15.5899 14.1805 15.5311 14.1805 15.467V5.72341ZM9.01717 14.2234H10.1003V7.22341H9.01717V14.2234ZM11.2607 14.2234H12.3438V7.22341H11.2607V14.2234Z"
                      fill="#4F4F4F" />
                  </svg>
                  Excluir
                </button>
              </div>
            </div>
          </div>

        </div>

        <button class="nxp-continue-btn mt-12" :style="{ background: color }" type="button" @click="saveSkills">
          Salvar
        </button>

      </div>
    </div>

    <vs-popup title="" :active.sync="popupActive">
      <div class="nxp-modal-content">
        <h2 class="nxp-modal-title mb-4 flex items-center">
          <svg class="mr-2" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M2.06543 20.25L11.9999 3.75L21.9344 20.25H2.06543ZM4.37493 18.95H19.6249L11.9999 6.25L4.37493 18.95ZM11.9947 17.5577C12.1937 17.5577 12.3623 17.4904 12.5004 17.3558C12.6386 17.2211 12.7077 17.0542 12.7077 16.8552C12.7077 16.6562 12.6403 16.4877 12.5057 16.3495C12.371 16.2113 12.2042 16.1423 12.0052 16.1423C11.8062 16.1423 11.6376 16.2096 11.4994 16.3442C11.3613 16.4789 11.2922 16.6458 11.2922 16.8448C11.2922 17.0438 11.3595 17.2123 11.4942 17.3505C11.6288 17.4887 11.7957 17.5577 11.9947 17.5577ZM11.3499 14.9423H12.6499V10.1423H11.3499V14.9423Z"
              fill="#DE2348" />
          </svg>
          Excluindo habilidade
        </h2>
        <p class="nxp-modal-paragraph mb-8">
          Tem certeza que você quer excluir a habilidade
          <b>{{ skill_to_remove.skill }}</b>
          ?
          <br /><br />
          <b>Atenção!</b> esta ação é permanente e não poderá ser desfeita
        </p>
        <div class="flex flex-row space-x-2">
          <button class="nxp-secondary-btn" @click="deletePopupActive = false" color="dark" type="flat">
            Manter habilidade
          </button>
          <button class="nxp-cancel-btn" @click="doRemoveSkill" color="danger" type="filled">
            Excluir habilidade
          </button>
        </div>
      </div>
    </vs-popup>

    <vs-popup title="" :active.sync="popupSave">
      <div class="nxp-modal-content">
        <h2 class="nxp-modal-title mb-4 flex items-center">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
            <path
              d="M11.9947 16.785C12.1937 16.785 12.3622 16.7177 12.5004 16.583C12.6386 16.4484 12.7077 16.2815 12.7077 16.0825C12.7077 15.8835 12.6403 15.715 12.5057 15.5768C12.371 15.4388 12.2042 15.3698 12.0052 15.3698C11.8062 15.3698 11.6376 15.437 11.4994 15.5715C11.3612 15.7062 11.2922 15.873 11.2922 16.072C11.2922 16.271 11.3595 16.4396 11.4942 16.5778C11.6288 16.716 11.7957 16.785 11.9947 16.785ZM11.3499 13.5313H12.6499V7.5313H11.3499V13.5313ZM12.0084 21.3543C10.7566 21.3543 9.57757 21.1175 8.4714 20.6438C7.36523 20.1701 6.39707 19.5184 5.5669 18.6885C4.73674 17.8587 4.08465 16.8913 3.61065 15.7863C3.13682 14.6815 2.8999 13.5009 2.8999 12.2445C2.8999 10.9882 3.13674 9.81113 3.6104 8.7133C4.08407 7.61546 4.73582 6.65146 5.56565 5.8213C6.39549 4.99113 7.3629 4.33905 8.4679 3.86505C9.57274 3.39121 10.7533 3.1543 12.0097 3.1543C13.266 3.1543 14.4431 3.39113 15.5409 3.8648C16.6387 4.33846 17.6027 4.99021 18.4329 5.82005C19.2631 6.64988 19.9152 7.6153 20.3892 8.7163C20.863 9.81746 21.0999 10.994 21.0999 12.2458C21.0999 13.4976 20.8631 14.6766 20.3894 15.7828C19.9157 16.889 19.264 17.8571 18.4342 18.6873C17.6043 19.5175 16.6389 20.1695 15.5379 20.6435C14.4367 21.1174 13.2602 21.3543 12.0084 21.3543ZM11.9999 20.0543C14.1666 20.0543 16.0082 19.296 17.5249 17.7793C19.0416 16.2626 19.7999 14.421 19.7999 12.2543C19.7999 10.0876 19.0416 8.24596 17.5249 6.7293C16.0082 5.21263 14.1666 4.4543 11.9999 4.4543C9.83324 4.4543 7.99157 5.21263 6.4749 6.7293C4.95824 8.24596 4.1999 10.0876 4.1999 12.2543C4.1999 14.421 4.95824 16.2626 6.4749 17.7793C7.99157 19.296 9.83324 20.0543 11.9999 20.0543Z"
              fill="#309E3A" />
          </svg>
          Você tem habilidades não salvas
        </h2>
        <p class="nxp-modal-paragraph mb-8">
          Deseja salvar as habilidades antes de fechar?
        </p>
        <div class="flex flex-row space-x-2">
          <button class="nxp-secondary-btn" @click="justClose" color="dark" type="flat">
            Fechar sem salvar
          </button>
          <button class="nxp-continue-btn" @click="saveSkills" color="danger" type="filled">
            Salvar e fechar
          </button>
        </div>
      </div>
    </vs-popup>

  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { ModelSelect } from "vue-search-select";
import vSelect from "vue-select";

export default {
  components: {
    ModelSelect,
    "v-select": vSelect
  },
  data: () => ({
    skills: [],
    experiences: [],
    payload: {
      skill: "",
      time: "",
      period: "",
      index: 0
    },
    skill_error: "",
    skill_to_remove: {},
    popupActive: false,
    popupSave: false
  }),
  watch: {
    skills(value) {
      console.log("watch skills", value);
    }
  },
  computed: {
    ...mapState("skill", ["experienciesSkills"]),
    ...mapState("company", ["company"]),
    color() {
      return this.$store.state.company.company.base_hexcolor || "#1551b1";
    },
    backgroundColor() {
      return this.company.base_hexcolor + '2D' || "#1551b12D";
    },
  },
  methods: {
    justClose() {
      this.popupSave = false;
      setTimeout(() => {
        this.$router.back();
      }, 500);
    },
    closePage() {
      if (this.skills.length > 0) {
        this.popupSave = true;
      } else {
        this.$router.back();
      }
    },

    addSkillToArray() {
      if (this.payload.skill.length <= 40) {
        this.skills.push({
          skill: this.payload.skill,
          index: this.payload.index,
          time: this.payload.time,
          period: this.payload.period
        });
        this.payload.skill = "";
        this.payload.index = 0;
        this.payload.time = 0;
        this.payload.period = "month";
      }
    },

    saveSkills() {
      this.popupSave = false;
      if (this.payload.skill.length > 0) {
        this.skills.push({
          skill: this.payload.skill,
          index: this.payload.index,
          time: this.payload.time,
          period: this.payload.period
        });
      }

      if (this.skills.length === 0) {
        this.$vs.notify({
          title: "Erro",
          text: "Adicione uma habilidade",
          color: "danger"
        });
        return;
      }

      const { company_label } = this.$router.history.current.params;

      this.$vs.loading({
        text: "Salvando..."
      });

      this.$http
        .post(`api/v1/talent/${company_label}/user/talent?step=skills`, {
          skills: [
            ...this.skills
          ]
        })
        .then(async response => {
          this.$vs.loading.close();

          this.payload = {
            ...this.payload,
            id: response.data.data.skills[0].id,
            index: response.data.data.skills[0].index
          };

          this.skills.push(this.payload);

          await this.$store.dispatch("skill/store", { ...this.payload });

          this.$router.back();

        })
        .catch(() => {
          this.$vs.loading.close();
        });
    },

    onChange(e) {
      if (e.target.name === "skill") {
        const value = e.target.value;

        if (value.length > 40) {
          this.skill_error = "Você atingiu o limite de 40 caracteres";
        } else {
          this.skill_error = "";
        }

        if (value.includes(",")) {
          this.payload.skill = value.replace(",", "").trim();
          this.addSkillToArray();
        } else {
          this.payload.skill = value;
        }

        this.payload.index = 0;
        this.payload.time = 0;
        this.payload.period = "month";
      }
    },

    onRemoveSkill(index) {
      this.skill_to_remove = this.skills[index];
      this.skill_to_remove.index = index;
      this.popupActive = true;
    },

    async doRemoveSkill() {

      const index = this.skill_to_remove.index;

      this.$store.dispatch("skill/delete", { ...this.skill_to_remove });

      this.skills.splice(index, 1);

      this.skill_to_remove = {};

      this.popupActive = false;
    },

  },
  created() {
    window.scroll(0, 0);
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/talent/views/steps/step.scss";

.wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  padding: 16px;
  background: #fff;

  @media screen and (min-width: 768px) {
    padding: 36px;
  }
}

.closeBtn {
  display: flex;
  justify-content: flex-end;
}

.title {
  display: flex;
  justify-content: center;

  h1 {
    font-size: 20px;
  }
}

.content {
  padding: 16px 0;
  display: flex;
  justify-content: center;
}

.group {
  width: 100%;
  margin: 16px auto;

  @media only screen and (min-width: 1020px) {
    width: 70%;
  }
}

.button {
  width: 100%;
  display: flex;
  padding: 1rem;
  color: white;
  font-size: 1.25rem;
  border: 0;
  border-radius: 5px;
  justify-content: center;
  background-color: #1551b1;
}
</style>
